import Stripes from './components/Stripes'
import AOSWrapper from './components/AOSWrapper'
import Cards from './components/Cards';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {gsap} from 'gsap';
import Parallax from './components/Parallax';
import ParallaxImage from './components/ParallaxImage';

const Animations = async () => {
    gsap.registerPlugin(ScrollTrigger)
    if (ScrollTrigger.getAll().length) {
        ScrollTrigger.killAll()
        ScrollTrigger.clearScrollMemory()
        ScrollTrigger.refresh()
    }

    return await Promise.all([AOSWrapper(), Cards(), Parallax(), ParallaxImage(), Stripes()])
}

export default Animations
